import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://trackapi.haydevs.com',
  withCredentials: true, // for httpOnly refresh token cookie
});

// Request interceptor: attach access token from memory and org context for Master Admin
api.interceptors.request.use((config) => {
  const token = window.__accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // If Master Admin is viewing an organization, send that context
  const viewingOrgAsAdmin = localStorage.getItem('viewingOrgAsAdmin');
  if (viewingOrgAsAdmin) {
    config.headers['X-Viewing-Org'] = viewingOrgAsAdmin;
  }

  return config;
});

// Response interceptor: refresh on 401, retry once
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const isAuthRoute = error.config.url?.includes('/api/auth/');
    if (error.response?.status === 401 && !error.config._retry && !isAuthRoute) {
      error.config._retry = true;
      try {
        const storedRefreshToken = localStorage.getItem('refreshToken');
        const { data } = await axios.post(
          `${import.meta.env.VITE_API_URL || 'https://trackapi.haydevs.com'}/api/auth/refresh`,
          { refreshToken: storedRefreshToken },
          { withCredentials: true }
        );
        window.__accessToken = data.accessToken;
        error.config.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(error.config);
      } catch (refreshError) {
        window.__accessToken = null;
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
